import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import VideoShowcase from "@/components/site/VideoShowcase";
import WhyUs from "@/components/site/WhyUs";
import AboutFounder from "@/components/site/AboutFounder";
import Testimonials from "@/components/site/Testimonials";
import ClientLogos from "@/components/site/ClientLogos";
import Contact from "@/components/site/Contact";
import FinalCta from "@/components/site/FinalCta";
import SiteLayout from "@/components/site/SiteLayout";
import usePageMeta from "@/hooks/usePageMeta";

export default function Landing() {
  usePageMeta(
    "Gold Mind Business — Digital Marketing & Growth in New Delhi",
    "Gold Mind Business is a results-driven digital marketing partner in Delhi. We build complete growth systems — performance marketing, creative strategy, funnels, social media, local SEO and AI automation — that generate consistent leads, sales and revenue."
  );
  return (
    <SiteLayout testId="landing-page">
      <Hero />
      <Services />
      <VideoShowcase />
      <WhyUs />
      <AboutFounder />
      <Testimonials />
      <ClientLogos />
      <Contact />
      <FinalCta />
    </SiteLayout>
  );
}
